import { createElement as h } from "react"
import { useSelector } from "react-redux"

import { Theme, ThemeProvider } from "@cirrus/ui-kit"

import { SkinsModel } from "../model/index.js"

export const Provider = ({ children }) => {
  const { initialized, ...properties } = useSelector(SkinsModel.state.theme),
    theme = initialized ? properties : Theme.from()

  return h(ThemeProvider, { theme, children })
}
